<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>题库包：</p>
          <input type="text" placeholder="请输入题库包" v-model="obj.title">
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题库包列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加题库包</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543;">
                <span @click="paperSub(item)">
                  {{item.type==1?'模拟卷':'练习题'}}管理
                </span>
                <span @click="editShow(item)">
                  编辑
                </span>
                <span @click="removeSub(item)">
                  删除 
                </span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加类型':'编辑类型'}}</p>
        <form>
          <div class="write-txt">
            <p>题库包名称：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>题库包类型：</p>
            <select v-model="addObj.type" @change="bankSub" :disabled="showType=='add'?false:true">
              <option value="">请选择</option>
              <option value="1">模拟卷</option>
              <option value="2">练习题</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getQuebankPackageList,saveQuebankPackage,delQuebankPackage } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'题库包名称'},
        {id:4,title:'创建时间'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        mtid:'',
        page:1,
        rows:10,
      },
      addObj:{
        mtid:'',
        name:'',
        type:''
      },
      totalPage:0,
      userData:{
        authority:[],
      },
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.obj.mtid = this.addObj.mtid = this.$route.query.id;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      this.addObj.name = '';
      this.addObj.type = '';
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请选择题库包！');
        return false;
      } else if(this.addObj.type == '') {
        that.$message('请选择题库包类型！');
        return false;
      }
      saveQuebankPackage(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.addObj.name = '';
      if(this.addObj.qpid){
        delete this.addObj.qpid;
      }
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getQuebankPackageList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.addObj.name = '';
    },

    editShow(e){
      this.showType = 'edit';
      this.addObj.qpid = e.qpid;
      this.addObj.name = e.name;
      this.addObj.type = e.type;
      console.log(this.addObj)
    },

    removeSub(e){
      var that = this;
      delQuebankPackage({qpid:e.qpid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    paperSub(e){
      var that = this;
      if(e.type ==1){
        that.$router.push('/imitate?mtid='+this.obj.mtid+'&qpid='+e.qpid);
      } else {
        that.$router.push('/exercises?mtid='+this.obj.mtid+'&qpid='+e.qpid);
      }
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 25%;
}


</style>



// WEBPACK FOOTER //
// src/exam/pack.vue